import { create } from 'zustand';

// ─── Aktiver Stammbaum (Mandant) ────────────────────────────────────────────
//
// Hält NUR den aktiven Stammbaum – nicht zu verwechseln mit `useTreeStore`,
// das den Canvas-Zustand (Auswahl, Zoom, Sidebar) verwaltet.
//
// Die ID wird in localStorage gespiegelt, damit ein Reload im selben Baum
// landet. Der API-Client hängt sie als `X-Tree-Id` an jeden Request.

const STORAGE_KEY = 'genealogy.activeTreeId';

function readStored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null; // z.B. Safari-Privatmodus
  }
}

function writeStored(id: string | null): void {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* Speicher nicht verfügbar – Auswahl gilt dann nur für diese Sitzung */
  }
}

interface TreeContextState {
  activeTreeId: string | null;
  setActiveTree: (id: string | null) => void;
  /** Verwirft den gemerkten Baum (z.B. nach 403/404 vom Server). */
  clearActiveTree: () => void;
}

export const useTreeContextStore = create<TreeContextState>((set) => ({
  activeTreeId: readStored(),

  setActiveTree: (id) => {
    writeStored(id);
    set({ activeTreeId: id });
  },

  clearActiveTree: () => {
    writeStored(null);
    set({ activeTreeId: null });
  },
}));

/** Für Nicht-React-Kontexte (Axios-Interceptor). */
export function getActiveTreeId(): string | null {
  return useTreeContextStore.getState().activeTreeId;
}
